import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  InputAdornment,
  TextField,
  Button,
  Box,
} from "@mui/material";
import classes from "./FaqSection.module.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SearchIcon } from "../../../components/Icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagedataFunction } from "../../../utilities/language";
import { useNavigate } from "react-router-dom";

const FaqSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [serachValue, setSearchValue] = useState("");
  const [viewAll, setViewAll] = useState(false);
  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const viewAllFn = () => {
    setViewAll(!viewAll);
  };

  const filteredProblems = ProblemsList?.filter((item) =>
    item.question.toLowerCase().includes(serachValue.toLowerCase())
  );

  const filteredFaqs = (viewAll ? Dummy : FAQ_List)?.filter((item) =>
    item.question.toLowerCase().includes(serachValue.toLowerCase())
  );

  const hasResults = filteredProblems.length > 0 || filteredFaqs.length > 0;

  return (
    <div>
      <Box
        sx={{
          mb: 3,
          mt: 0.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TextField
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            width: "300px", // Optional: limit width of search
          }}
          placeholder="search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          className={classes.teamMemberSearch}
          id="firstNameinput"
          value={serachValue}
          onChange={(e) => setSearchValue(e.target.value)}
          size="small"
        />
        <Button
          variant="contained"
          className={classes.faqButton}
          onClick={() => navigate("/contact-us")}
          sx={{ height: "40px" }}
        >
          {ln?.contact_us}
        </Button>
      </Box>
      {filteredProblems.length > 0 && (
        <Box sx={{ mb: 3, mt: 0.5 }}>
          <div className={classes.FaqHeaderSection}>
            <Typography className={classes.FaqHeadings}>
              {ln?.problems}
            </Typography>
            <Typography
              className={classes.FaqViewAllButtons}
              onClick={viewAllFn}
            >
              {!viewAll ? ln?.view_all : "Back"}
            </Typography>
          </div>
          <div className={classes.AccordiansContainers}>
            {filteredProblems.map((item, index) => (
              <Accordion key={index} className={classes.AccordianTab}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>{`${index + 1}. ${item.question}`}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>{item.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </Box>
      )}
      {filteredFaqs.length > 0 && (
        <Box sx={{ mt: 0.5 }}>
          <div className={classes.FaqHeaderSection}>
            <Typography className={classes.FaqHeadings}>{ln?.faqs}</Typography>
            <Typography
              className={classes.FaqViewAllButtons}
              onClick={viewAllFn}
            >
              {!viewAll ? ln?.view_all : "Back"}
            </Typography>
          </div>
          <div className={classes.AccordiansContainers}>
            {filteredFaqs.map((item, index) => (
              <Accordion key={index} className={classes.AccordianTab}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>{`${index + 1}. ${item.question}`}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>{item.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </Box>
      )}
      {!hasResults && serachValue && (
        <Box
          sx={{
            mt: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography variant="h6" color="textSecondary">
            No results match your keyword "{serachValue}"
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Try a different search term or check out our popular FAQs above.
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default FaqSection;

const ProblemsList = [
  {
    question: "What is an attendance tracking and management application?",
    answer: `An attendance tracking and management application is nothing but using the best of technology to keep a track of the most important stakeholders in your business - your employees! Gone are the days when manual registers and entry cards were enough to track employee activity during working hours. Employee attendance and tracking apps like TeamPlayer are the way ahead to make your taskforce productive.

TeamPlayer uses a simple user-friendly interface to keep track of all your employees' attendance records and access it whenever you need to. Every person using the app, will have their unique profile, through which tasks, requests and updates can be raised. The app is designed to automatically notify all parties in real time when they are raised and completed. It also maintains easily accessible data of everything. Attendance tracking and employee management apps like TeamPlayer are actually the need of the hour for every business owner.
`,
  },
  {
    question: "Why use an attendance tracking and management application?",
    answer: `There are many reasons to use an employee attendance tracking and management application in the business world. To start off with it is an easy, simple to use, technologically friendly and time efficient way to keep track of your business. Besides the fact that it helps to eliminate buddy proxies, extensive paperwork and gaps due to human error, apps like these just help you to build a better discipline to run your business. With several features that streamline everyday working, attendance tracking and management applications like TeamPlayer are needed so that small and medium sized businesses don't lose out on opportunities because of a lack of a certain set of guidelines in the company. To summarise, it is a progressive and essential way to manage your workforce`,
  },
  {
    question: "How is the Team Player attendance app different?",
    answer: `Simply put, the biggest benefit TeamPlayer Application has over others is ease of operation. While most other apps in the market offer complicated and data heavy procedures, making it difficult for employees to use the software, TeamPlayer is different. We rely on the ease of access and technologically simple operations which make using the software a seamless part of your employees daily work schedule. The app is secure and ensures all your data is safe. TeamPlayer is unique because once you use it, you will definitely get used to it, thanks to how simple it makes work life for your entire organization!`,
  },
];

const FAQ_List = [
  {
    question: "How do I sign up as a Team Leader? ",
    answer: `Click on sign up/register button and select “Team Leader”. Fill in your details and select any one of plans depending on your requirement
Wow! You’re all set
`,
  },
  {
    question: "How do I add my team members?",
    answer: `Once you have selected a plan, Go to the “My Teams” tab and create a Team. Once done, go to the team and click on “Add member”, fill in the details of the person you wish to add.
Upon completing the above, the team member can download the app and sign up as a team player.
`,
  },
];

const Dummy = [
  {
    question: "What is an attendance tracking and management application?",
    answer:
      "An attendance tracking and management application is nothing but using the best of technology to keep a track of the most important stakeholders in your business - your employees! Gone are the days when manual registers and entry cards were enough to track employee activity during working hours. Employee attendance and tracking apps like TeamPlayer are the way ahead to make your taskforce productive. /n TeamPlayer uses a simple user-friendly interface to keep track of all your employees' attendance records and access it whenever you need to. Every person using the app, will have their unique profile, through which tasks, requests and updates can be raised. The app is designed to automatically notify all parties in real time when they are raised and completed. It also maintains easily accessible data of everything. Attendance tracking and employee management apps like TeamPlayer are actually the need of the hour for every business owner.",
  },

  {
    question: "Why use an attendance tracking and management application?",
    answer:
      "There are many reasons to use an employee attendance tracking and management application in the business world. To start off with it is an easy, simple to use, technologically friendly and time efficient way to keep track of your business. Besides the fact that it helps to eliminate buddy proxies, extensive paperwork and gaps due to human error, apps like these just help you to build a better discipline to run your business. With several features that streamline everyday working, attendance tracking and management applications like TeamPlayer are needed so that small and medium sized businesses don't lose out on opportunities because of a lack of a certain set of guidelines in the company. To summarise, it is a progressive and essential way to manage your workforce.",
  },

  {
    question: "How is the Team Player attendance app different?",
    answer:
      "Simply put, the biggest benefit TeamPlayer Application has over others is ease of operation. While most other apps in the market offer complicated and data heavy procedures, making it difficult for employees to use the software, TeamPlayer is different. We rely on the ease of access and technologically simple operations which make using the software a seamless part of your employees daily work schedule. The app is secure and ensures all your data is safe. TeamPlayer is unique because once you use it, you will definitely get used to it, thanks to how simple it makes work life for your entire organization!",
  },

  {
    question: "How do I sign up as a Team Leader?",
    answer:
      "Click on sign up/register button and select “Team Leader”. Fill in your details and select any one of plans depending on your requirement",
  },

  {
    question: "How do I add my team members?",
    answer:
      "Once you have selected a plan, Go to the “My Teams” tab and create a Team. Once done, go to the team and click on “Add member”, fill in the details of the person you wish to add.",
  },

  {
    question: "How do I sign up as a Team player?",
    answer:
      "Once you have been added to a team, you can download the app and click on sign up/register button and select “Team Player”. Fill in your details and you are all set.",
  },

  {
    question: "How does Team player app calculate attendance?",
    answer:
      "A team player(employee) has to punch “Time in” and “Time out” on the app to capture attendance every day.",
  },

  {
    question: "How do I view my team’s attendance?",
    answer:
      "On the dashboard you will be able to see attendance for the day. You can click on it to view further details and select a duration. Or you can also download a detailed attendance report.",
  },

  {
    question: "How do I download attendance and other reports?",
    answer:
      "Click on the three lines ☰ on the top left corner, go to Reports. Then select the report you wish to download, then select the employee and click on download. You can download the reports in excel or pdf format as per your convenience.",
  },

  {
    question: "Can I override attendance calculated?",
    answer: "No, overriding of attendance is not possible in Team Player app.",
  },

  {
    question: "How and why should I mark holidays?",
    answer:
      "Click on the three lines ☰ on the top left corner and select mark a holiday. Select the dates you want to mark as holidays and save changes.",
  },

  {
    question: "How does location tracking work?",
    answer:
      "After an employee has timed in, every few seconds the app takes the employee’s GPS location until they time out.",
  },

  {
    question: "When will my team members be tracked?",
    answer:
      "Your team members will be tracked only in their working hours i.e. between they Time in and Time out. ",
  },

  {
    question: "Why is location not updating after my team member has timed in?",
    answer:
      "In order to track a device, the app needs certain permissions and a good internet connection. Please make sure all necessary permissions have been given and if the problem persists, kindly reach out to our support team.",
  },

  {
    question: "How do I assign a task to my team member?",
    answer:
      "Go to the “Tasks” tab and you will see an “Assign a Task” button on the top right corner. Click on it and fill in all the necessary details to assign the task.",
  },

  {
    question: "How do I get updates on assigned tasks?",
    answer:
      "Once the employee reaches the location of an assigned task, the Team leader gets a notification unless the task requires confirmation in which case the employee has to open the app and provide confirmation.",
  },

  {
    question: "Is the Team Player app free?",
    answer:
      "Team Player app has a free trial period of 14 days where you can try and check if the app fits your requirements. Post that you would have to take one of our very affordable subscriptions based on your requirement.",
  },
];
